import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ad0e49fe"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "label"
}
const _hoisted_2 = { style: {"width":"100%"} }

import { PropType, computed } from 'vue';
import { DxSwitch } from 'devextreme-vue/switch';
import { FieldValidation } from 'acquaint-api/validation/FieldValidation';
import AcquaintDateBox from '../../ui/inputs/acquaint-date-box.vue';
import { FieldSize } from '@/enums/system/FieldSize';
import moment from 'moment';


export default /*#__PURE__*/_defineComponent({
  __name: 'date-toggle',
  props: {
    /** A string which represents a Date value, must be a blank string or a Date formatted in UTC e.g. 2023-05-31T11:03:17.422Z */
    /** 
     * The string value used with `v-model` to control the visibility or state of a modal or component.
     * @type {string}
     * @required
     */
    modelValue: {
        type: String,
        required: true,
        default: ""
    },
    /** 
     * The width of the field, defined by the `FieldSize` enum.
     * @type {FieldSize}
     * @ default: FieldSize.Full
     */
    width: {
        type: String as PropType<FieldSize>,
        default: FieldSize.Full
    },
    /** 
     * The maximum allowed date value for the input.
     * @type {Date}
     * @default: undefined
     */
    maxDate: {
        type: Date,
        default: undefined
    },
    /** 
     * Determines whether the control is read only.
     * @type {boolean}
     * @default false
     */
    readOnly: {
        type: Boolean,
        default: false
    },
    /** 
    * The label displayed for the control.
    * @type {String}
    * @default ''
    */
    label: {
        type: String,
        default: ''
    },
    /** 
     * The validation rules and constraints applied to the field. Defines the validation logic to ensure correct user input.
     * @type {FieldValidation}
     * @required
     */
    fieldValidation: {
        type: Object as PropType<FieldValidation>,
        required: true
    },
    /** 
     * Determines whether the time is included.
     * @type {boolean}
     * @default false
     */
    includeTime: {
        type: Boolean,
        default: false
    }
},
  emits: ['update:modelValue', 'toggleValueUpdated'],
  setup(__props, { emit }) {

const props = __props;



const dateValue = computed({
    get: () => props.modelValue,
    set: (value: string) => emit('update:modelValue', value)
});

const toggle = computed(() => !!dateValue.value)

/** Handles the Switch toggle event */
const onValueChanged = (e: any) => {
    emit('toggleValueUpdated', e.value);
    if (!e.value) {
        // if the toggle has been turned off, set the date to blank, which will hide the field
        dateValue.value = "";
    } else {
        if (dateValue.value === "") {
            // toggle enabled, set the date to now only if it was previously set to blank
            dateValue.value = props.includeTime ? moment().format('YYYY-MM-DDTHH:mm') : moment().format('YYYY-MM-DD');
        }
    }
}




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (__props.label)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(__props.label), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: "date-toggle-container",
      style: _normalizeStyle({ 'width': __props.width })
    }, [
      _createVNode(_unref(DxSwitch), {
        value: toggle.value,
        focusStateEnabled: false,
        switchedOffText: "No",
        switchedOnText: "Yes",
        onValueChanged: onValueChanged,
        readOnly: props.readOnly
      }, null, 8, ["value", "readOnly"]),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(AcquaintDateBox, {
          modelValue: dateValue.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((dateValue).value = $event)),
          "field-validation": __props.fieldValidation,
          maxDate: __props.maxDate,
          disabled: !toggle.value,
          "include-time": __props.includeTime,
          readOnly: props.readOnly
        }, null, 8, ["modelValue", "field-validation", "maxDate", "disabled", "include-time", "readOnly"])
      ])
    ], 4)
  ], 64))
}
}

})